import React, {useState, useEffect} from "react";
import {Modal, Button} from "antd";
import {ZoomInOutlined, ZoomOutOutlined} from '@ant-design/icons';
import PDF from "react-pdf-js";
import { saveAs } from 'file-saver';

const PdfViewer = ({name, pdf, onCancel})=> {
    const [showPdf, setShowPdf] = useState(false)
    const [myPdf, setMyPdf] = useState(null);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(null);
    const [scale, setScale] = useState(1);
    const [thumbnailLoaded, setThumbnailLoaded] = useState(false);

    const onDocumentComplete = (numPages) =>{
        setPages(numPages)
    }

    const onThumbnailComplete = (numPages) => {
        setThumbnailLoaded(true);
    }

    useEffect(() => {
        // Fetch the PDF as a blob to enable downloading
        const fetchPdf = async () => {
            const response = await fetch(pdf);
            const blob = await response.blob();
            setPdfBlob(blob);
        };

        fetchPdf();
    }, [pdf]);

    const handleDownload = () => {
        if (pdfBlob) {
            saveAs(pdfBlob, name );
        }
    };

    const onDocumentError = (err) => {
        console.error('pdf viewer error:', err);
    }

    const onSetScale = (type) =>{
        var newScale = type ? scale + 0.1 : scale - 0.1;

        if (newScale > 2){
            newScale = 2
        } else if (newScale < 0.1){
            newScale = 0.1
        }

        setScale(newScale)
    }

    const onPage = (type) =>{
        var newPage = type ? page + 1 : page - 1

        if (newPage > pages){
            newPage = 1
        } else if (newPage < 1){
            newPage = pages
        }

        setPage(newPage)
    }

    const zoomStyle = {
        marginLeft: 10,
        cursor: 'pointer'
    }

    const footer = <div className="footer">
        <Button onClick={()=>onPage(0)}>Vorherige Seite</Button>
        <div>
            <span style={{textAlign: 'center'}}>Page {page} of {pages}</span>
            <ZoomOutOutlined style={{...zoomStyle, opacity: scale === 0.1 ? 0.5 : 1}} onClick={()=>onSetScale(0)}/>
            <ZoomInOutlined style={{...zoomStyle, opacity: scale === 2 ? 0.5 : 1}} onClick={()=>onSetScale(1)}/>
            <span>{Math.round(scale * 100)}%</span>
        </div>
        <Button onClick={()=>onPage(1)}>Nächste Seite</Button>
    </div>

    // Container style for buttons with thumbnail background
    const buttonContainerStyle = {
        position: 'relative',
        display: 'flex',
        gap: '10px',
        padding: '15px 20px',
        marginTop: '10px',
        minHeight: '80px',
        height: '218px',
        alignItems: 'center',
        overflow: 'hidden'
    };

    const thumbnailBackgroundStyle = {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        background: 'rgba(0, 0, 0, 0)',
        bottom: '0',
        opacity: '0.95',
        zIndex: '0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const buttonStyle = {
        position: 'relative',
        zIndex: '1',
        marginLeft: '0'
    };

    return (<>
        <Modal maskClosable={false}
               onCancel={() => setShowPdf(false)}
               visible={showPdf}
               width={"50%"}
               bodyStyle={{height: 600, overflowY: 'auto'}}
               style={{ top: 20 }}
               footer={footer}
        >
            <div className="pdfWrapper">
                <PDF
                    file={pdf}
                    onDocumentComplete={onDocumentComplete}
                    onDocumentError={onDocumentError}
                    page={page}
                    scale={scale}
                />
            </div>
        </Modal>

        <div style={buttonContainerStyle}>
            {/* Thumbnail background - now properly positioned */}
            <div style={thumbnailBackgroundStyle}>
                <div style={{
                    transform: 'scale(0.85)',
                    transformOrigin: 'center center',
                    height: '400px'
                }}>
                    <PDF
                        file={pdf}
                        onDocumentComplete={onThumbnailComplete}
                        onDocumentError={(err) => console.log('Thumbnail error:', err)}
                        page={1}
                        scale={0.5}
                    />
                </div>
            </div>

            {/* Buttons with higher z-index */}
            <Button disabled={false} style={buttonStyle} onClick={handleDownload}>
                Download PDF
            </Button>
            <Button disabled={false} style={buttonStyle} onClick={()=>setShowPdf(!showPdf)}>
                PDF Datei anzeigen
            </Button>
        </div>
    </>)
};

export default PdfViewer;